import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import {
  IActivityScheduleBase,
  IActivityScheduleBlockBase,
  WaveSideEnum,
} from '../../models/activities';
import { IBookingBase } from '../../models/bookings';

interface IUpdateActivityScheduleBlocks {
  blockedDate: string;
}

interface IUpdateActivityScheduleProps {
  activityScheduleId: string;
  allowLinkBookings?: boolean;
  allowPartialTimeBookings?: boolean;
  bookingPrice: number;
  guestAdditionalBookingPrice: number;
  daysOfWeek: Array<number>;
  endDate?: string | null;
  endTime: string;
  isActive?: boolean;
  isVerified?: boolean;
  minUserExperience: number;
  modalityId?: string | null;
  scheduleBlocks: IUpdateActivityScheduleBlocks[];
  startDate: string;
  startTime: string;
  guestVacancies?: number | null;
  lodgerVacancies?: number | null;
  queueVacancies: number;
  totalVacancies?: number | null;
  waveSide?: WaveSideEnum;
}

export interface IUpdatedActivitySchedule extends IActivityScheduleBase {
  bookings: IBookingBase[];
  scheduleBlocks: IActivityScheduleBlockBase[];
}

interface IUpdateActivityScheduleResponse {
  activitySchedule: IUpdatedActivitySchedule;
  pendingBookings: IBookingBase[];
  pendingBookingQueues: unknown[];
}

export const updateActivitySchedulesService = async ({
  activityScheduleId,
  allowLinkBookings,
  allowPartialTimeBookings,
  bookingPrice,
  guestAdditionalBookingPrice,
  daysOfWeek,
  endDate,
  endTime,
  guestVacancies,
  lodgerVacancies,
  queueVacancies,
  isActive,
  isVerified,
  minUserExperience,
  modalityId,
  scheduleBlocks,
  startDate,
  startTime,
  totalVacancies,
  waveSide,
}: IUpdateActivityScheduleProps): Promise<IUpdatedActivitySchedule> => {
  const { data } = await jhsfBookingsApi.put<IUpdateActivityScheduleResponse>(
    `/activities/schedules/${activityScheduleId}`,
    {
      allowLinkBookings,
      allowPartialTimeBookings,
      bookingPrice,
      guestAdditionalBookingPrice,
      daysOfWeek,
      endDate,
      endTime,
      guestVacancies,
      lodgerVacancies,
      queueVacancies,
      isActive,
      minUserExperience,
      modalityId,
      scheduleBlocks,
      startDate,
      startTime,
      totalVacancies,
      waveSide,
    },
    { params: { isVerified } },
  );

  return data.activitySchedule;
};
